import { trackError } from '@proposify/frontend-observability';
import { useMutation } from '@tanstack/react-query';
import { openNotification } from 'components/notification';
import { useTranslation } from 'react-i18next';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';

export const useSaveDocumentAsTemplateMutation = ({ onSuccess, onError }: { onSuccess?: () => void; onError?: () => void }) => {
  const { t } = useTranslation();

  const { mutate: saveDocumentAsTemplate, isPending } = useMutation({
    mutationFn: async ({ contentId, templateName }: { contentId: string; templateName: string }) => {
      try {
        await apiDocumentServiceRepository.copyDocumentAsTemplate({ contentId, templateName });
      } catch (error) {
        trackError('frontend editor-menu copyDocumentAsTemplate failed', {
          message: error instanceof Error ? error.message : String(error),
          stack: error instanceof Error ? error.stack : undefined,
          errorFrom: 'proposify-frontend',
          cause: 'copyDocumentAsTemplate API call failed',
          contentId,
        });
        throw error;
      }
    },
    onSuccess: () => {
      openNotification({
        title: t('library.save_template_success_title'),
        description: t('library.save_template_success_message'),
        type: 'success',
      });
      onSuccess?.();
    },
    onError: (error: Error) => {
      trackError(error);
      openNotification({
        title: t('library.save_template_error_title'),
        description: t('library.save_template_error_message'),
        type: 'error',
      });
      onError?.();
    },
  });

  return { saveDocumentAsTemplate, isLoading: isPending };
};
